import Footer from 'modules/common/components/footer';
import Navbar from 'modules/common/components/navbar';
import BuyImage from 'modules/common/assests/images/buy-img.png';

export default function FAQBuyPage() {
  return (
    <>
      <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover h-auto">
        <Navbar />
      </div>
      <div className='relative py-16 bg-black overflow-hidden'>
        <div className='relative px-4 sm:px-6 lg:px-8'>
          <div className='text-lg max-w-screen-lg mx-auto'>
            <h1>
              <span className='block text-base text-center text-[#00ce1b] font-semibold tracking-wide uppercase'>
                Buy Coins
              </span>
              <span className='mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-white sm:text-4xl'>
                How to buy nft using GreenArt Coin?
              </span>
            </h1>
            <figure className='mt-10'>
              <img className='w-full rounded-lg' src={BuyImage} alt='' />
            </figure>
          </div>
          <div className='mt-6 prose prose-green max-w-screen-lg text-gray-300 mx-auto'>
            <h2 className='text-white'>How to buy an NFT</h2>
            <p>
              Once you’ve found an NFT you like, how do you actually purchase
              it? There are three main ways to buy an NFT using GreenArt Coin:
              “buy now,” auctions, and offers.
            </p>
            <h2 className='text-white'>Buy now</h2>
            <p>
              NFTs listed to “buy now” are listed at a set price. They can be
              purchased any time during the sale period and without any
              additional involvement from the seller. This is the simplest
              method, and is a lot like buying on other e-commerce websites.
            </p>

            <h2 className='text-white'>Auctions</h2>
            <p>
              When an NFT is up for auction, potential buyers can bid on the
              item. The NFT will either go to the highest bidder, or the seller
              can choose to accept any offer during the auction.
            </p>
            <h2 className='text-white'>Offers</h2>
            <p>
              You can make an offer on any item using GreenArt Coin, even if
              it’s not listed for sale. You can also make an offer on a listed
              item, if you want to offer less than its listed sale price.
            </p>
            <h2 className='text-white'>
              The purchase process: A step-by-step guide
            </h2>
            <p>Let’s walk through how to buy an NFT.</p>
            <h3 className='text-gray-200'>
              1. As we discussed above, there are multiple ways to buy an NFT.
              For this example, we’ll buy an NFT that’s listed for sale by
              clicking the “Buy now” button.
            </h3>
            <h3 className='text-gray-200'>2. Connect your crypto wallet</h3>
            <p>
              If you haven’t already connected and set up your crypto wallet,
              you’ll be prompted to do so during this step.
            </p>
            <h3 className='text-gray-200'>3. Choose your payment method</h3>
            <p>
              Next, you’ll be prompted to choose if you’d like to pay with
              crypto or with a card. For this example, we’ll use a card. If you
              want to buy using crypto, you’ll need to load your wallet with
              cryptocurrency.
            </p>
            <p>
              Every wallet is different, but there are two main ways to fund
              your crypto wallet:
            </p>
            <h3 className='text-gray-200'>4. Review fees</h3>
            <p>
              You may notice that your total is higher than the listed price for
              that NFT. This is due to network (“gas”) fees and, if you’re
              paying with a card, processing fees. The gas fee occurs on all
              transactions on the blockchain and the amount varies based on a
              variety of factors, such as how many people are using the network
              at that moment. GreenArt Coin does not receive these fees.
            </p>
            <h3 className='text-gray-200'>5. Enter your payment information</h3>
            <p>
              Follow the prompts and enter your information to complete your
              purchase. If this is your first time purchasing with a card you
              may be asked to verify your identity.
            </p>
            <h3 className='text-gray-200'>6. Your purchase is complete!</h3>
            <p>
              Once you’ve entered all your necessary information and clicked
              “Pay”, your NFT purchase is officially complete and has been
              written to the blockchain. Congratulations on your NFT purchase!
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
